import { Modal, ModalBody, ModalHeader, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, ModalFooter } from "reactstrap"
import { Component } from "react"
import auth from "../../../utils/auth"

class EditableCardParametrizacao extends Component {
    userInfo = auth.getUserInfo()

    state = {
        modalDelete: false
    }

    removerParametro = () => {
        this.props.removerParametroImportado(this.props.index)
        this.setState({ modalDelete: false })
    }

    render() {
        let { detalhes, parametrizacao } = this.props
        
        return (
            <>
                <Modal isOpen={this.state.modalDelete} toggle={() => this.setState({ modalDelete: !this.state.modalDelete })}>
                    <ModalHeader>Confirmar exclusão</ModalHeader>
                    <ModalBody>
                        <p style={{ fontSize: '14px' }}>Você tem certeza que deseja deletar? Essa ação não poderá ser desfeita</p>
                    </ModalBody>
                    <ModalFooter>
                        <div className="float-right" style={{ marginTop: '20px' }}>
                            <button onClick={() => this.setState({ modalDelete: false })} className="hdv-btn-forms hdv-btn-yellow">Cancelar</button>
                            <button onClick={this.removerParametro} className="hdv-btn-forms hdv-btn-red">Confirmar</button>
                        </div>
                    </ModalFooter>
                </Modal>

                <div className="parametrizacao-btn-editar" style={{ backgroundColor: '#d5efce' }}>
                    <div style={{ height: "90%" }}>
                        <div className="pt-3 text-truncate parametrizacao-title" >
                            <input
                                type="text"
                                className={!parametrizacao.descricao?.trim() ? 'has-error' : ''}
                                value={parametrizacao.descricao ?? ''}
                                onChange={(e) => this.props.updateParametroImportado(this.props.index, 'descricao', e.target.value)}
                            />
                            <div style={{ marginTop: '8px' }}>
                                <small><strong>{parametrizacao.identificacao}</strong></small>
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="col-md-6 pl-4">
                                {(parametrizacao.tipo_grafico === "barra")
                                    ?
                                    <i className="fa fa-chart-bar" id="chart-type"></i>
                                    :
                                    <i className="fa fa-chart-line" id="chart-type"></i>
                                }
                                <br />
                                <span>Tipo Gráfico</span>
                            </div>
                            <div className="col-md-6 pr-4">
                                <strong style={{ fontSize: "17px" }}>({parametrizacao.unidade})</strong>
                                <br />
                                <span>Unidade</span>
                            </div>
                        </div>
                    </div>

                    <UncontrolledDropdown direction="down">
                        <DropdownToggle nav>
                            <div className="btns-parametrizacao-novo" style={{ background: "#a6d1a0" }}>
                                <span style={{ textAlign: "center", padding: "6px", fontSize: "13px" }}>Ações</span>
                            </div>
                        </DropdownToggle>
                        <DropdownMenu className="mini-modal">
                            <DropdownItem onClick={() => this.setState({ modalDelete: true })}>
                                <i className="fa fa-times"></i> Excluir
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </div>
            </>
        )
    }
}

export default EditableCardParametrizacao